/**
 * Bundle listing ATC — expand marketing SKU into parent + accessories
 * (same cart line properties as PDP bundle-tiers / collection package ATC).
 */
(function () {
  'use strict';
  if (window.__d1BundleListingAtcLoaded) return;
  window.__d1BundleListingAtcLoaded = true;

  function readConfig() {
    var el = document.getElementById('d1-bundle-listing-atc-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_) {
      return null;
    }
  }

  function newBundleInstanceId() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function collapseAccessoryLines(ids, qtys) {
    if (window.d1BundleTiers && typeof window.d1BundleTiers.collapseAccessoryLines === 'function') {
      return window.d1BundleTiers.collapseAccessoryLines(ids, qtys);
    }
    var seen = {};
    var out = [];
    (ids || []).forEach(function (rawId, index) {
      var id = parseInt(rawId, 10);
      if (!(id > 0) || seen[id]) return;
      seen[id] = true;
      var q = qtys && qtys[index] != null ? parseInt(qtys[index], 10) : 1;
      out.push({ id: id, quantity: q > 0 ? q : 1 });
    });
    return out;
  }

  function buildItems(config, qty) {
    var instanceId = newBundleInstanceId();
    var tierId = String(config.tierId || '');
    var tierName = String(config.tierName || '');
    var parentId = String(config.parentProductId || '');
    var bundlePrice = String(config.bundlePriceCents || 0);
    var mainProperties = {
      _d1_bundle_instance: instanceId,
      _d1_bundle_selection: tierId,
    };
    if (tierName) mainProperties.Bundle = tierName;
    var listingSubmit = document.querySelector('[data-d1-main-submit], form[action*="/cart/add"] [name="add"]');
    if (window.D1AccessoryAtc && window.D1AccessoryAtc.stampPreorderProps) {
      window.D1AccessoryAtc.stampPreorderProps(
        mainProperties,
        window.D1AccessoryAtc.isPreorderControl(listingSubmit),
      );
    }

    var items = [
      {
        id: config.parentVariantId,
        quantity: qty,
        properties: mainProperties,
      },
    ];

    collapseAccessoryLines(config.accessoryIds, config.accessoryQuantities).forEach(function (line) {
      var n = line.id;
      var perPackage = line.quantity;
      var accQty = Math.max(1, perPackage) * qty;
      var props = {
        _d1_accessory_upsell: 'true',
        _d1_bundle_tier: tierId,
        _d1_bundle_parent: parentId,
        _d1_bundle_instance: instanceId,
        _d1_bundle_name: tierName,
        _d1_bundle_price_cents: bundlePrice,
      };
      if (tierName) props.Bundle = tierName;
      items.push({ id: n, quantity: accQty, properties: props });
    });

    return items;
  }

  function setBusy(productForm, busy) {
    if (window.d1BundleTiers && typeof window.d1BundleTiers.setBusy === 'function') {
      window.d1BundleTiers.setBusy(productForm, busy);
      return;
    }
    if (!productForm) return;
    productForm.d1AddingToCart = !!busy;
    var submit = productForm.querySelector('[type="submit"]');
    if (submit) {
      submit.toggleAttribute('disabled', !!busy);
      submit.setAttribute('aria-busy', busy ? 'true' : 'false');
      submit.classList.toggle('loading', !!busy);
    }
  }

  function bind() {
    var config = readConfig();
    if (!config) return;

    if (config.error) {
      console.warn('[d1-bundle-listing-atc]', config.error);
    }

    document.querySelectorAll('product-form').forEach(function (pf) {
      if (pf.d1BundleListingBound) return;
      var form = pf.querySelector('form[data-type="add-to-cart-form"]') || pf.querySelector('form');
      if (!form) return;
      pf.d1BundleListingBound = true;

      form.addEventListener(
        'submit',
        function (e) {
          if (pf.d1AddingToCart) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }

          if (config.error || !(config.parentVariantId > 0) || !config.accessoryIds || !config.accessoryIds.length) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var msg =
              (config && config.error) ||
              'This bundle is not ready to add yet. Please open it from the main product page.';
            if (typeof window.d1ShowToast === 'function') window.d1ShowToast(msg);
            else alert(msg);
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();

          var qtyInput = form.querySelector('[name="quantity"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          var items = buildItems(config, qty);
          if (items.length < 2) {
            if (typeof window.d1ShowToast === 'function') {
              window.d1ShowToast('Bundle accessories are missing. Please re-sync this package.');
            }
            return;
          }

          // Care Refresh upsell (same UX as main PDP bundle ATC)
          if (
            window.d1CareRefresh &&
            window.d1CareRefresh.enabled &&
            typeof window.d1CareRefresh.openForBundleItems === 'function' &&
            document.getElementById('CareRefreshModal')
          ) {
            if (window.d1CareRefresh.openForBundleItems(pf, items)) return;
          }

          setBusy(pf, true);

          var done = function () {
            setBusy(pf, false);
          };

          if (window.d1BundleTiers && typeof window.d1BundleTiers.batchAdd === 'function') {
            window.d1BundleTiers
              .batchAdd(items)
              .finally(done)
              .catch(function () {});
            return;
          }

          // Fallback if bundle-tiers.js not ready yet
          var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          var sections =
            cart && cart.getSectionsToRender
              ? cart.getSectionsToRender().map(function (s) {
                  return s.id;
                })
              : [];
          var payload = { items: items };
          if (sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
          }
          var addUrl =
            (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') +
            '.js';
          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload),
          })
            .then(function (r) {
              return r.json().then(function (body) {
                if (!r.ok || body.status) {
                  throw new Error(body.description || body.message || 'Add failed');
                }
                if (cart) {
                  if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                  cart.renderContents(body);
                }
              });
            })
            .catch(function (err) {
              var msg = (err && err.message) || 'Could not add bundle to cart.';
              if (typeof window.d1ShowToast === 'function') window.d1ShowToast(msg);
              else alert(msg);
            })
            .finally(done);
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('product-info:loaded', bind);
})();
